const { PRODUCT_LIST_GROUPING } = require('constants/content');

const { SHOW_PRICE, SHOW_RATING_WITH_TOTAL_COUNT } = PRODUCT_LIST_GROUPING;

const CONSTRUCTOR_PODS = {
    YMAL: 'ymal-test',
    RFY: 'rfy-test'
};

const GROUPING = {
    YMAL: [SHOW_PRICE, SHOW_RATING_WITH_TOTAL_COUNT]
};

module.exports = {
    CONSTRUCTOR_PODS,
    GROUPING
};
